import { render, staticRenderFns } from "./LinkTenantSettingAdd.vue?vue&type=template&id=a30eaed6&scoped=true&"
import script from "./LinkTenantSettingAdd.vue?vue&type=script&lang=js&"
export * from "./LinkTenantSettingAdd.vue?vue&type=script&lang=js&"
import style0 from "./LinkTenantSettingAdd.vue?vue&type=style&index=0&id=a30eaed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30eaed6",
  null
  
)

export default component.exports